import { useMemo } from 'react';
export function useBlockDataEventLocationsIds(event) {
    const locationRefs = useMemo(() => {
        var _a, _b;
        return (_b = (_a = event === null || event === void 0 ? void 0 : event.locationRef) === null || _a === void 0 ? void 0 : _a.map((location) => location === null || location === void 0 ? void 0 : location.locationId)) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
    }, [event === null || event === void 0 ? void 0 : event.locationRef]);
    return locationRefs;
}
